import { BaseOrder } from "./BaseOrder";
import { OrderId } from "./OrderId";
import { OrderResponse } from "./OrderResponse";
import { OrderStatus } from "./OrderStatus";
import { OrderTypes } from "./OrderTypes";
import { OrderPayslipRequest } from "./Order";
import { DocumentationAreaActorOrderRetrievalMethod } from "./DocumentationAreaActorOrderRetrievalMethod";

export type OrderPayslipParams = {
  id: OrderId;
  request: OrderPayslipRequest;
  responses: OrderResponse[];
  retrievalMethods: DocumentationAreaActorOrderRetrievalMethod[];
  status: OrderStatus;
  expired: boolean;
};

export type OrderPayslipCreateParams = {
  id?: OrderId;
  request: OrderPayslipRequest;
};

export class OrderPayslip extends BaseOrder<OrderPayslipRequest> {
  expired: boolean;

  constructor({ id, request, responses, retrievalMethods, status, expired }: OrderPayslipParams) {
    super(id, OrderTypes.PAYSLIP, request, responses, retrievalMethods, status);
    this.expired = expired;
  }

  public isExpired(): boolean {
    return this.expired;
  }

  static fromPrimitives(data: any): OrderPayslip {
    return new OrderPayslip({
      id: data.id,
      request: data.request,
      responses:
        data.responses?.map(
          (response: any) =>
            new OrderResponse({
              id: response.id,
              createdAt: new Date(response.createdAt),
              inputFiles: response.inputFiles || [],
              outputFiles: response.outputFiles || [],
              status: response.status,
              statusMessages: response.statusMessages || [],
              retrievalMethodOutput: response.retrievalMethodOutput || null,
            }),
        ) || [],
      retrievalMethods:
        data.retrievalMethods?.map(
          (method: any) =>
            new DocumentationAreaActorOrderRetrievalMethod({
              name: method.name,
              config: method.config || null,
            }),
        ) || [],
      status: data.status,
      expired: data.expired || false,
    });
  }
}
